import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Switch from 'housecall-ui/dist/DesignSystem/Inputs/Switches/Switch';
import FormControlLabel from 'housecall-ui/dist/DesignSystem/Inputs/FormControls/FormControlLabel';
import { getAppEnabled, getCanUseApp } from '../../../../Resources/Organization/Apps/AppsData';
import { toggleEnabledWithEntity } from '../Redux/Actions';
import { E_COMMERCE } from '../AppsData';
import { openPayWallForFeature } from 'components/PayWall/Redux/Actions';
import RedirectTo from '../../../Common/RedirectTo';
import { ACTIVATED, DEACTIVATED, trackBetaFeatureToggled } from '../../../Services/Analytics/TrackEventsService';

const ECommerceButton = () => {
  const appEnabled = useSelector(getAppEnabled(E_COMMERCE));
  const canUseApp = useSelector(getCanUseApp(E_COMMERCE));
  const dispatch = useDispatch();
  const handleClickManageVendors = () => RedirectTo.vendors();
  const handleUpgrade = () => dispatch(openPayWallForFeature(E_COMMERCE));
  const handleToggleAppEnabled = () => {
    dispatch(toggleEnabledWithEntity(E_COMMERCE)).then(() =>
      dispatch(trackBetaFeatureToggled(E_COMMERCE, appEnabled ? DEACTIVATED : ACTIVATED))
    );
  };

  if (!appEnabled) return null;
  if (!canUseApp) {
    return (
      <Button variant="contained" color="primary" onClick={handleUpgrade}>
        Upgrade
      </Button>
    );
  }

  return (
    <Grid container>
      <Grid item>
        <FormControlLabel
          control={<Switch checked={appEnabled} onChange={handleToggleAppEnabled} />}
          label={appEnabled ? 'Active' : 'Disabled'}
        />
      </Grid>
      {appEnabled && (
        <Grid item>
          <Button variant="contained" color="primary" onClick={handleClickManageVendors}>
            Manage Vendors
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default ECommerceButton;
